if (!customElements.get("mathilda-insta-feed")) {
  class MathildaInstaFeed extends HTMLElement {
    constructor() {
      super();
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector("[data-slider]");
      this.prevBtn = this.querySelector(".mathilda-insta-feed__nav--prev");
      this.nextBtn = this.querySelector(".mathilda-insta-feed__nav--next");
      this.track = this.querySelector(".mathilda-insta-feed__track");

      if (!this.slider || !this.prevBtn || !this.nextBtn || !this.track) return;

      this.setDynamicTypeSizes();
      this.updateButtons();

      this.prevBtn.addEventListener("click", this.onPrevClick);
      this.nextBtn.addEventListener("click", this.onNextClick);
      this.slider.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onResize);
    }

    disconnectedCallback() {
      if (this.prevBtn) {
        this.prevBtn.removeEventListener("click", this.onPrevClick);
      }

      if (this.nextBtn) {
        this.nextBtn.removeEventListener("click", this.onNextClick);
      }

      if (this.slider) {
        this.slider.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);
    }

    setDynamicTypeSizes() {
      const isMobile = window.innerWidth <= 989;
      const headingSize = isMobile
        ? this.dataset.headingSizeMobile || null
        : this.dataset.headingSize || null;
      const textSize = isMobile
        ? this.dataset.textSizeMobile || null
        : this.dataset.textSize || null;

      if (headingSize) {
        this.style.setProperty("--heading-size", `${headingSize}px`);
      }

      if (textSize) {
        this.style.setProperty("--text-size", `${textSize}px`);
      }
    }

    getGap() {
      if (!this.track) return 0;
      const styles = window.getComputedStyle(this.track);
      return parseFloat(styles.gap || styles.columnGap || 0);
    }

    getStep() {
      const firstCard = this.querySelector(".mathilda-insta-feed__card");
      if (!firstCard) return 0;
      return firstCard.offsetWidth + this.getGap();
    }

    updateButtons() {
      if (!this.slider || !this.prevBtn || !this.nextBtn) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const isAtStart = this.slider.scrollLeft <= 5;
      const isAtEnd = this.slider.scrollLeft >= maxScroll - 5;

      this.prevBtn.style.opacity = isAtStart ? "0.35" : "1";
      this.nextBtn.style.opacity = isAtEnd ? "0.35" : "1";
      this.prevBtn.style.pointerEvents = isAtStart ? "none" : "auto";
      this.nextBtn.style.pointerEvents = isAtEnd ? "none" : "auto";
    }

    onPrevClick() {
      const step = this.getStep();
      if (!step) return;

      this.slider.scrollBy({
        left: -step,
        behavior: "smooth",
      });
    }

    onNextClick() {
      const step = this.getStep();
      if (!step) return;

      this.slider.scrollBy({
        left: step,
        behavior: "smooth",
      });
    }

    onScroll() {
      this.updateButtons();
    }

    onResize() {
      this.setDynamicTypeSizes();
      this.updateButtons();
    }
  }

  customElements.define("mathilda-insta-feed", MathildaInstaFeed);
}
